/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const UserPermissionDto = {
    AdminPanelAccess: 'ADMIN_PANEL_ACCESS',
    AdminAccountsManagement: 'ADMIN_ACCOUNTS_MANAGEMENT',
    AdminEmployeesManagement: 'ADMIN_EMPLOYEES_MANAGEMENT',
    AdminHrbpPermissions: 'ADMIN_HRBP_PERMISSIONS',
    AdminDataManagement: 'ADMIN_DATA_MANAGEMENT',
    AdminDataFileDownload: 'ADMIN_DATA_FILE_DOWNLOAD',
    AdminRolesManagement: 'ADMIN_ROLES_MANAGEMENT',
    AdminChatDocuments: 'ADMIN_CHAT_DOCUMENTS',
    AdminDictionariesView: 'ADMIN_DICTIONARIES_VIEW',
    AdminDictionariesEdit: 'ADMIN_DICTIONARIES_EDIT',
    AdminDevPlanTesterAccess: 'ADMIN_DEV_PLAN_TESTER_ACCESS',
    AdminDevPlanTesterCreate: 'ADMIN_DEV_PLAN_TESTER_CREATE',
    AdminImpersonate: 'ADMIN_IMPERSONATE',
    StructureTabAccess: 'STRUCTURE_TAB_ACCESS',
    StructureCurrentAccess: 'STRUCTURE_CURRENT_ACCESS',
    StructureSimulationAccess: 'STRUCTURE_SIMULATION_ACCESS',
    SuccessionTabAccess: 'SUCCESSION_TAB_ACCESS',
    SuccessionDashboardAccess: 'SUCCESSION_DASHBOARD_ACCESS',
    SuccessionHistoryAccess: 'SUCCESSION_HISTORY_ACCESS',
    SuccessionSearchAccess: 'SUCCESSION_SEARCH_ACCESS',
    SuccessionReportDownload: 'SUCCESSION_REPORT_DOWNLOAD',
    SuccessionSuccessorAdd: 'SUCCESSION_SUCCESSOR_ADD',
    SuccessionSuccessorDelete: 'SUCCESSION_SUCCESSOR_DELETE',
    SuccessionSuccessorsView: 'SUCCESSION_SUCCESSORS_VIEW',
    SuccessionEmployeesView: 'SUCCESSION_EMPLOYEES_VIEW',
    SuccessionCommentChange: 'SUCCESSION_COMMENT_CHANGE',
    SuccessionCareerPathChange: 'SUCCESSION_CAREER_PATH_CHANGE',
    SuccessionEmployeeColorChange: 'SUCCESSION_EMPLOYEE_COLOR_CHANGE',
    SuccessionHistoryExport: 'SUCCESSION_HISTORY_EXPORT',
    SuccessionExpatChange: 'SUCCESSION_EXPAT_CHANGE',
    SuccessionExcommChange: 'SUCCESSION_EXCOMM_CHANGE',
    SuccessionExclamationMarkChange: 'SUCCESSION_EXCLAMATION_MARK_CHANGE',
    SuccessionTalentPanelView: 'SUCCESSION_TALENT_PANEL_VIEW',
    SuccessionTalentPanelChange: 'SUCCESSION_TALENT_PANEL_CHANGE',
    EmployeesBasicData: 'EMPLOYEES_BASIC_DATA',
    EmployeesAllAccess: 'EMPLOYEES_ALL_ACCESS',
    EmployeesTabAccess: 'EMPLOYEES_TAB_ACCESS',
    TeamTabAccess: 'TEAM_TAB_ACCESS',
    AreaTabAccess: 'AREA_TAB_ACCESS',
    TeamOverviewAccess: 'TEAM_OVERVIEW_ACCESS',
    TeamListAccess: 'TEAM_LIST_ACCESS',
    EmployeesView: 'EMPLOYEES_VIEW',
    EmployeesEdit: 'EMPLOYEES_EDIT',
    EmployeesPhotoEdit: 'EMPLOYEES_PHOTO_EDIT',
    EmployeesDevelopmentPlanView: 'EMPLOYEES_DEVELOPMENT_PLAN_VIEW',
    EmployeesDevelopmentPlanEdit: 'EMPLOYEES_DEVELOPMENT_PLAN_EDIT',
    EmployeesDevelopmentPlanStepStatusEdit: 'EMPLOYEES_DEVELOPMENT_PLAN_STEP_STATUS_EDIT',
    EmployeesDevelopmentPlanStatusEdit: 'EMPLOYEES_DEVELOPMENT_PLAN_STATUS_EDIT',
    EmployeesDevelopmentPlanDirectionEdit: 'EMPLOYEES_DEVELOPMENT_PLAN_DIRECTION_EDIT',
    EmployeesDevelopmentPlanDownload: 'EMPLOYEES_DEVELOPMENT_PLAN_DOWNLOAD',
    EmployeesCardDownload: 'EMPLOYEES_CARD_DOWNLOAD',
    EmployeesChatAccess: 'EMPLOYEES_CHAT_ACCESS',
    EmployeesDevelopmentPlanCreate: 'EMPLOYEES_DEVELOPMENT_PLAN_CREATE',
    EmployeesOrganizationalAssignment: 'EMPLOYEES_ORGANIZATIONAL_ASSIGNMENT',
    EmployeesAiSummary: 'EMPLOYEES_AI_SUMMARY',
    EmployeesMtInfo: 'EMPLOYEES_MT_INFO',
    EmployeesFeedback: 'EMPLOYEES_FEEDBACK',
    EmployeesFeedbackEdit: 'EMPLOYEES_FEEDBACK_EDIT',
    EmployeesEmploymentHistory: 'EMPLOYEES_EMPLOYMENT_HISTORY',
    EmployeesTrainingsHistory: 'EMPLOYEES_TRAININGS_HISTORY',
    EmployeesMatrix: 'EMPLOYEES_MATRIX',
    EmployeesAnnualEvaluationResult: 'EMPLOYEES_ANNUAL_EVALUATION_RESULT',
    EmployeesMdrPotentialReview: 'EMPLOYEES_MDR_POTENTIAL_REVIEW',
    EmployeesTrainingNeedsSurvey: 'EMPLOYEES_TRAINING_NEEDS_SURVEY',
    EmployeesTrainingNeedsSurveyEdit: 'EMPLOYEES_TRAINING_NEEDS_SURVEY_EDIT',
    EmployeesSelfProfile: 'EMPLOYEES_SELF_PROFILE',
    EmployeesActivitiesActiveView: 'EMPLOYEES_ACTIVITIES_ACTIVE_VIEW',
    EmployeesActivitiesArchivedView: 'EMPLOYEES_ACTIVITIES_ARCHIVED_VIEW',
    EmployeesActivitiesDocumentsView: 'EMPLOYEES_ACTIVITIES_DOCUMENTS_VIEW',
    EmployeesActivitiesDocumentsDownload: 'EMPLOYEES_ACTIVITIES_DOCUMENTS_DOWNLOAD',
    EmployeesActivitiesDocumentsManage: 'EMPLOYEES_ACTIVITIES_DOCUMENTS_MANAGE',
    CertificationManagementRead: 'CERTIFICATION_MANAGEMENT_READ',
    CertificationManagementWrite: 'CERTIFICATION_MANAGEMENT_WRITE',
    CertificationResultsRead: 'CERTIFICATION_RESULTS_READ',
    CertificationFlashcardRead: 'CERTIFICATION_FLASHCARD_READ',
    CertificationDcReportRead: 'CERTIFICATION_DC_REPORT_READ',
    CertificationExamDayManagement: 'CERTIFICATION_EXAM_DAY_MANAGEMENT',
    CertificationExecution: 'CERTIFICATION_EXECUTION',
    NewsManagementRead: 'NEWS_MANAGEMENT_READ',
    NewsManagementWrite: 'NEWS_MANAGEMENT_WRITE',
    NewsRead: 'NEWS_READ',
    ProfessionalActivityDefinitionRead: 'PROFESSIONAL_ACTIVITY_DEFINITION_READ',
    ProfessionalActivityDefinitionWrite: 'PROFESSIONAL_ACTIVITY_DEFINITION_WRITE',
    HrStaffStatisticsView: 'HR_STAFF_STATISTICS_VIEW',
    HrBirthdaysView: 'HR_BIRTHDAYS_VIEW',
    AdminDevelopmentCycleConfigView: 'ADMIN_DEVELOPMENT_CYCLE_CONFIG_VIEW',
    AdminDevelopmentCycleConfigEdit: 'ADMIN_DEVELOPMENT_CYCLE_CONFIG_EDIT',
    ChatAttachmentsUse: 'CHAT_ATTACHMENTS_USE',
    AdminLegalDocumentsView: 'ADMIN_LEGAL_DOCUMENTS_VIEW',
    AdminLegalDocumentsEdit: 'ADMIN_LEGAL_DOCUMENTS_EDIT',
    AdminAccountsPasswordReset: 'ADMIN_ACCOUNTS_PASSWORD_RESET'
} as const;

export type UserPermissionDto = typeof UserPermissionDto[keyof typeof UserPermissionDto];



